// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import FamilyActionType from './family-details.types';
import {
	familyIncomeSuccess,
	familyIncomeFailure,
	familyIncomeUserResponseChanged,
	fetchFamilyMemberUserResponseChanged,
	fetchFamilyMemberFailure,
	fetchFamilyMemberSuccess,
	familyMemberAddResponseChanged,
	familyMemberAddFailure,
	familyMemberAddSuccess,
	fetchParticularFamFailure,
	fetchParticularFamSuccess,
	fetchParticularFamResponseChanged,
	deleteFamilyFailure,
	deleteFamilySuccess,
	deleteFamilyResponseChanged,
	verifyFamilyAadharOtpResponseChanged,
	verifyFamilyAadharOtpFailure,
	verifyFamilyAadharOtpSuccess,
	verifyValidateFamilyAadharOtpResponseChanged,
	verifyValidateFamilyAadharOtpFailure,
	verifyValidateFamilyAadharOtpSuccess,
} from './family-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	DeleteMemberFamilyAPI,
	familyMemberAddDetails,
	familyMemberFetch,
	familyMemberFetchParticular,
	familyMemberIncomeAdd,
	verifyFamilyAadharOtpAPI,
	verifyValidateFamilyAadharOtpAPI,
} from './family-details.service';

//** ***************** FAMILY MEMBER INCOME ADD START *********************** */
export function* AddFamilyIncome({ payload }: any) {
	try {
		const key = 'AddMemberFamilyIncome';
		const {
			companyID,
			databaseName,
			memberID,
			familyMonthlyIncome,
			familyMonthlyExpenses,
			familyMonthlyExtraSpent,
			familyType,
			userID,
			cityType,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			FamilyMonthlyIncome: familyMonthlyIncome,
			FamilyMonthlyExpenses: familyMonthlyExpenses,
			FamilyMonthlyExtraSpent: familyMonthlyExtraSpent,
			FamilyType: familyType,
			OfficerID: userID,
			CityType: cityType,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(familyMemberIncomeAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(familyIncomeFailure(responseData.data));
		} else {
			yield put(familyIncomeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(familyIncomeFailure(error));
	}
}

export function* AddFamilyIncomeResponseClear() {
	yield put(familyIncomeUserResponseChanged());
}

export function* onFamilyIncomeAddStart() {
	yield takeLatest(FamilyActionType.FAMILY_MEMBER_INCOME_START, AddFamilyIncome);
}

export function* onFamilyIncomeAddResponseRest() {
	yield takeLatest(
		FamilyActionType.FAMILY_MEMBER_INCOME_RESPONSE_REST_START,
		AddFamilyIncomeResponseClear,
	);
}
//** ***************** FAMILY MEMBER INCOME ADD END *********************** */

//** ***************** FAMILY MEMBER FETCH START *********************** */
export function* fetchFamilyMember({ payload }: any) {
	try {
		const key = 'FetchMemberDataKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			MemberID: payload.memberID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(familyMemberFetch, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFamilyMemberFailure(responseData.data));
		} else {
			yield put(fetchFamilyMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFamilyMemberFailure(error));
	}
}

export function* FetchFamilyResponseClear() {
	yield put(fetchFamilyMemberUserResponseChanged());
}

export function* onFamilyFetchStart() {
	yield takeLatest(FamilyActionType.FETCH_FAMILY_MEMBERS_START, fetchFamilyMember);
}

export function* onFamilyFetchResponseRest() {
	yield takeLatest(
		FamilyActionType.FETCH_FAMILY_MEMBERS_RESPONSE_REST_START,
		FetchFamilyResponseClear,
	);
}
//** ***************** FAMILY MEMBER FETCH END *********************** */

//** ***************** FAMILY MEMBER ADD START *********************** */
export function* AddMemberFamilyDetails({ payload }: any) {
	try {
		const key = 'AddMemberFamilyDetails';

		const {
			familyMemberID,
			databaseName,
			memberID,
			companyID,
			name,
			aadharNumber,
			gender,
			dob,
			age,
			occupation,
			monthlyIncome,
			annualIncome,
			relationship,
			education,
			educationDept,
			educationCenter,
			educationType,
			familyType,
			isSponsoredChildren,
			isChildrenWithDisability,
			userID,
		} = payload;

		const jsonData = {
			FamilyMemberID: familyMemberID,
			DatabaseName: databaseName,
			MemberID: memberID,
			CompanyID: companyID,
			FamilyMemberName: name,
			FamilyMemberAadharNumber: aadharNumber,
			FamilyMemberGender: gender,
			FamilyMemberDOB: dob,
			FamilyMemberAge: age,
			FamilyMemberOccupation: occupation,
			FamilyMemberMonthlyIncome: monthlyIncome,
			FamilyMemberAnnualIncome: annualIncome,
			FamilyMemberRelationship: relationship,
			FamilyMemberEducation: education,
			FamilyMemberEducationDept: educationDept,
			FamilyMemberEducationCenter: educationCenter,
			FamilyMemberEducationType: educationType,
			FamilyType: familyType,
			SponsoredChildren: isSponsoredChildren,
			ChildrenWithDisability: isChildrenWithDisability,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(familyMemberAddDetails, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(familyMemberAddFailure(responseData.data));
		} else {
			yield put(familyMemberAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(familyMemberAddFailure(error));
	}
}

export function* AddFamilyResponseClear() {
	yield put(familyMemberAddResponseChanged());
}

export function* onFamilyAddStart() {
	yield takeLatest(FamilyActionType.ADD_FAMILY_MEMBERS_START, AddMemberFamilyDetails);
}

export function* onFamilyAddResponseRest() {
	yield takeLatest(
		FamilyActionType.ADD_FAMILY_MEMBERS_RESPONSE_REST_START,
		AddFamilyResponseClear,
	);
}
//** ***************** FAMILY MEMBER ADD END *********************** */

//** ***************** FAMILY MEMBER FETCH START *********************** */
export function* FetchMemberFamilyDetails({ payload }: any) {
	try {
		const key = 'FetchMemberDataKey';

		const { MemberFamiliesID, databaseName, MemberID } = payload;

		const jsonData = {
			FamilyMemberID: MemberFamiliesID,
			DatabaseName: databaseName,
			MemberID: MemberID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(familyMemberFetchParticular, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchParticularFamFailure(responseData.data));
		} else {
			yield put(fetchParticularFamSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchParticularFamFailure(error));
	}
}

export function* FetchMemberFamilyResponseClear() {
	yield put(fetchParticularFamResponseChanged());
}

export function* onFamilyFethcIndividualStart() {
	yield takeLatest(
		FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_START,
		FetchMemberFamilyDetails,
	);
}

export function* onFamilyFetchDetailsRest() {
	yield takeLatest(
		FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_RESPONSE_REST_START,
		FetchMemberFamilyResponseClear,
	);
}
//** ***************** FAMILY MEMBER FETCH END *********************** */

//** ***************** FAMILY MEMBER DELETE START *********************** */
export function* DeleteMemberFamilyDetails({ payload }: any) {
	try {
		const key = 'DeleteFamMemberDataKey';

		const {
			familyMemberID,
			databaseName,
			memberID,
			familyMemberTotalIncome,
			familyMemberMonthlyIncome,
		} = payload;

		const jsonData = {
			FamilyMemberID: familyMemberID,
			DatabaseName: databaseName,
			MemberID: memberID,
			Secratekey: key,
			TotalIncome: familyMemberTotalIncome,
			FamMemberIncome: familyMemberMonthlyIncome,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(DeleteMemberFamilyAPI, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteFamilyFailure(responseData.data));
		} else {
			yield put(deleteFamilySuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteFamilyFailure(error));
	}
}

export function* DeleteMemberFamilyResponseClear() {
	yield put(deleteFamilyResponseChanged());
}

export function* onFamilyMemberDeleteStart() {
	yield takeLatest(FamilyActionType.DELETE_FAMILY_MEMBERS_START, DeleteMemberFamilyDetails);
}

export function* onFamilyDeleteDetailsRest() {
	yield takeLatest(
		FamilyActionType.DELETE_FAMILY_MEMBERS_RESPONSE_REST_START,
		DeleteMemberFamilyResponseClear,
	);
}
//** ***************** FAMILY MEMBER DELETE END *********************** */

//** ***************** VERIFY AADHAR OTP START *********************** */
export function* toVerifyFamilyAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';

		const {
			companyID,
			userID,
			databaseName,
			memberID,
			generalCompanyID,
			memberCredential,
			type,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			MemberCredential: memberCredential,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(verifyFamilyAadharOtpAPI, verifyData, payload.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyFamilyAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyFamilyAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyFamilyAadharOtpFailure(error));
	}
}

export function* VerifyFamilyAadharOtpResponseClear() {
	yield put(verifyFamilyAadharOtpResponseChanged());
}

export function* onVerifyFamilyAadharOtpStart() {
	yield takeLatest(FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_START, toVerifyFamilyAadharOtp);
}

export function* onVerifyFamilyAadharOtpRest() {
	yield takeLatest(
		FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyFamilyAadharOtpResponseClear,
	);
}
		//** ***************** VERIFY AADHAR OTP END *********************** */

//** ***************** VERIFY VALIDATE AADHAR OTP START *********************** */
export function* toVerifyValidateFamilyAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';

		const { companyID, userID, databaseName, memberID, generalCompanyID, randNum, otp, type } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			RandNum: randNum,
			Otp: otp,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyValidateFamilyAadharOtpAPI,
			verifyData,
			payload.serviceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyValidateFamilyAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyValidateFamilyAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyValidateFamilyAadharOtpFailure(error));
	}
}

export function* VerifyValidateFamilyAadharOtpResponseClear() {
	yield put(verifyValidateFamilyAadharOtpResponseChanged());
}

export function* onVerifyValidateFamilyAadharOtpStart() {
	yield takeLatest(
		FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_START,
		toVerifyValidateFamilyAadharOtp,
	);
}

export function* onVerifyValidateFamilyAadharOtpRest() {
	yield takeLatest(
		FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyValidateFamilyAadharOtpResponseClear,
	);
}
//** ***************** VERIFY VALIDATE AADHAR OTP END *********************** */

export function* familyDetailSaga() {
	yield all([
		call(onFamilyIncomeAddStart),
		call(onFamilyIncomeAddResponseRest),
		call(onFamilyFetchResponseRest),
		call(onFamilyFetchStart),
		call(onFamilyAddResponseRest),
		call(onFamilyAddStart),
		call(onFamilyFetchDetailsRest),
		call(onFamilyFethcIndividualStart),
		call(onFamilyMemberDeleteStart),
		call(onFamilyDeleteDetailsRest),
		call(onVerifyFamilyAadharOtpStart),
		call(onVerifyFamilyAadharOtpRest),
		call(onVerifyValidateFamilyAadharOtpStart),
		call(onVerifyValidateFamilyAadharOtpRest),
	]);
}
